export default {
    isLogged: false,
    user: null,
    loginCaptchaActivo: false,
    formasPago: [],
    loadingFormasPago: false,
    snackbarEmail: true,
    snackbarEmail2: true
}